import { API_CONVERSIONS } from "@/configs/global";
import { IServerResponse } from "@/api/types";
import { axiosInstance } from "@/api/index";
import { AxiosResponse } from "axios";
import { FormattedItem } from "@/utils/CellsFromBff";
import { IConversionEvent, IMarkingReportItem } from "@/api/types/conversions";

/**
 *  Получение отчета по маркировке
 */
type MarkingReport = IServerResponse<FormattedItem<IMarkingReportItem>[]>
export async function getMarkingReport(
    params: { offer_id: number, period_from: string, period_to: string, columns: string[] },
    isExport?: boolean,
): Promise<MarkingReport> {
    const headers = isExport ? { 'Accept': "text/csv" } : {};
    return axiosInstance.request<MarkingReport>({
        headers,
        method: 'GET',
        url: `${API_CONVERSIONS}employees/price-marking-report`,
        params,
    })
        .then((response: AxiosResponse<MarkingReport>) => response.data);
}

/**
 * События (история) по конверсии для сотрудника.
 */
export async function getEmployeeConversionEvents(
    conversionId: number | string,
    params: { limit: number; offset: number },
): Promise<IServerResponse<IConversionEvent[]>> {
    return axiosInstance.request<IServerResponse<IConversionEvent[]>>({
        method: 'GET',
        url: `${API_CONVERSIONS}employees/conversions/${conversionId}/events`,
        params,
    })
        .then((response: AxiosResponse<IServerResponse<IConversionEvent[]>>) => response.data);
}
